export const contact = [
  {
    icon: "@",
    url: "mailto:sunchusrikar@gmail.com",
    display: "sunchusrikar@gmail.com",
  },
  {
    icon: "G",
    url: "https://github.com/srikarsunchu",
    display: "github.com/srikarsunchu",
  },
  {
    icon: "L",
    url: "https://www.linkedin.com/in/srikar-sunchu-651314220/",
    display: "linkedin.com/in/srikar-sunchu",
  },
  {
    icon: "W",
    url: "https://www.srikarsunchu.com",
    display: "srikarsunchu.com",
  },
];
